module.exports = __webpack_public_path__ + "static/media/dr-donut.86976f95.jpg";